export const getLanguageFromHost = (): 'es' | 'en' => {
  return globalThis.location.hostname.includes('cuidadodesalud.gov') ? 'es' : 'en';
};
